import { z } from "zod";

export const allergyFormSchema = z
  .object({
    activeTab: z.enum(["ALLERGY", "DRUG_ALLERGY"]),
    name: z.string().optional(),
    allergyReaction: z.string().min(1, "Symptoms is required."),
    serious: z.boolean(),
    drugName: z.string().optional(),
    drugGenericName: z.string().optional(),
    ingredients: z.string().optional(),
    note: z.string().nullable().optional(),
  })
  .superRefine((data, ctx) => {
    if (data.activeTab === "ALLERGY" && !data.name?.trim()) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Name is required.",
        path: ["name"],
      });
    }

    if (data.activeTab === "DRUG_ALLERGY" && !data.drugName?.trim()) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: "Drug name is required.",
        path: ["drugName"],
      });
    }
  });
